import createIconComponent from './utils/createIconComponent';
import React from 'react';
const AlertLargeFail = createIconComponent({
  height: 125,
  width: 109,
  content: (
    <g>
      <path
        fill='#ED3431'
        d='M54.109 0l54.108 31.24v62.479l-54.108 31.24L0 93.719v-62.48L54.109 0z'
      />
      <path fill='#C81A17' d='M54.109 0V124.959L0 93.719v-62.48L54.109 0z' />
      <rect
        width='8'
        height='63.734'
        x='34.657'
        y='87.724'
        fill='#fff'
        rx='4'
        transform='rotate(-135 34.657 87.724)'
      />
      <rect
        width='8'
        height='63.734'
        x='29'
        y='42.657'
        fill='#fff'
        rx='4'
        transform='rotate(-45 29 42.657)'
      />
    </g>
  ),
});
AlertLargeFail.displayName = 'AlertLargeFail';
export default AlertLargeFail;
